import React from 'react';

const Input = ({ type, placeholder, value, onChange }) => {
    return (
        <input type={type}
               placeholder={placeholder}
               value={value}
               onChange={onChange}
               className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"/>
    );
};

export default Input;
